export const AIStarsModalIcon = () => (
  <svg viewBox="0 0 24 24" className="w-4 h-4">
    <defs>
      <linearGradient id="modalSparkleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#D946EF" />
        <stop offset="50%" stopColor="#8B5CF6" />
        <stop offset="100%" stopColor="#06B6D4" />
      </linearGradient>
      <linearGradient id="modalSmallSparkleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#A855F7" />
        <stop offset="100%" stopColor="#3B82F6" />
      </linearGradient>
    </defs>
    <path d="M15 2L18 10L26 12L18 14L15 22L12 14L4 12L12 10L15 2Z" fill="url(#modalSparkleGradient)"/>
    <path d="M3 4L4 7L7 8L4 9L3 12L2 9L-1 8L2 7L3 4Z" fill="url(#modalSmallSparkleGradient)" fillOpacity="0.7"/>
    <path d="M6 16L7 18L9 19L7 20L6 22L5 20L3 19L5 18L6 16Z" fill="url(#modalSmallSparkleGradient)" fillOpacity="0.5"/>
  </svg>
);
